export default __webpack_public_path__ + "static/media/chart.610fef10.png";